import React, { useState, useEffect } from "react";
import "./styles/Card2.css";

const Card = ({ index, item, onClick, addToCart, products }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        if (item.Img && item.Img.length > 0) {
            const interval = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % item.Img.length);
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [item.Img]);

    const handleAddToCart = (e) => {
        e.stopPropagation();
        addToCart(item, 1);
    };

    return (
        <div
            key={index}
            className="cards-item-card"
            onClick={onClick}
        >
            {item.isCombo ? (
                <div className="product-grid">
                    {Array.isArray(item.Products) &&
                        item.Products.map((productName, i) => {
                            const comboProduct = products?.[productName]; // Get combo product details
                            return (
                                <img
                                    key={i}
                                    src={comboProduct?.Img?.[0] || "/placeholder.jpg"}
                                    alt={comboProduct?.Name || "Unknown Product"}
                                    className="cards-combo-image"
                                />
                            );
                        })}
                </div>
            ) : (
                <div className="item-image">
                    <img src={item.Img?.[currentImageIndex] || "/placeholder.jpg"} alt={item.Name} className="cards-item-image" />
                </div>
            )}
            <div className="cards-item-details">
                <h3>{item.Name}</h3>
                <div className="cards-price-weight-list">
                    Rs. {item.Price}&nbsp;&nbsp;
                </div>
                <button className="ATC-button" onClick={handleAddToCart} style={{ marginBottom: "10px" }}>
                    Add to Cart
                </button>
            </div>
        </div>
    );
};

export default Card;


